import * as React from "react";

const IconHeaderMenuInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M17.036 13.913H.928c-.494 0-.928.47-.928 1.004C0 15.53.434 16 .928 16h16.108c.53 0 .964-.47.964-1.004 0-.613-.434-1.083-.964-1.083zm0-13.913H.928C.434 0 0 .47 0 1.004c0 .535.434 1.083.928 1.083h16.108c.53 0 .964-.47.964-1.004C18 .548 17.566 0 17.036 0zm0 6.957H.928C.434 6.957 0 7.427 0 8c0 .574.434 1.043.928 1.043h16.108c.53 0 .964-.47.964-1.043 0-.574-.434-1.043-.964-1.043z"
            />
        </svg>
    );
};

export default React.memo(IconHeaderMenuInactive);
